import { useEffect, useState } from 'react';
import { api } from '../services/api';

export function useMaintenance() {
    const [isActive, setIsActive] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkMaintenance();
    }, []);

    const checkMaintenance = async () => {
        try {
            // We fetch public settings which now include maintenance_mode
            const settings = await api.system.getPublicSettings();
            if (settings && settings.maintenance_mode === 'true') {
                setIsActive(true);
            } else {
                setIsActive(false);
            }
        } catch (e: any) {
            // If the API returns 503, it means maintenance is active (globally blocked)
            if (e.message && e.message.includes('503')) {
                setIsActive(true);
            }
            // Or if interceptor caught it
        } finally {
            setLoading(false);
        }
    };

    return { isActive, loading };
}
